export enum ExceptionsErrorUrl {
  Address = 'address',
  Vehicle = 'vehicle',
  Valid = 'valid',
  HealthCheck = 'health-check',
}
